<template>
    <van-nav-bar
        v-show="showNavBar"
        :title="title"
        fixed
        :safe-area-inset-top="true"
        z-index="10"
        border
        placeholder
        :left-arrow="leftArrow"
        @click-left="clickBack"
    >
    <template #right v-if="rightBtn">
        <img class="img" src="@/assets/images/tabbar/icon_1_active@2x.png" alt="" @click.stop="goHome" />
    </template>
    </van-nav-bar>
</template>

<script>
import store from "@/store";
import { mapState } from "vuex"
export default {
    name: 'NavBar',
    data(){
        return {
            showNavBar: true
        }
    } ,
    props: {
        title: {
            type: String,
            required: true
        },
        leftArrow:{
            type: Boolean,
            default: true
        },
        rightBtn: {
            type: Boolean,
            default: false
        },
    },
    mounted(){
        this.initNavBar()
    },
    computed: {
    ...mapState({
      KEEP_ALIVE_COMS: state=>state.routerCache.KEEP_ALIVE_COMS || []
    }),
  },
    methods: {
        initNavBar() {
            var u = navigator.userAgent
            if (u.indexOf('miniProgram') !== -1) {
                // 在微信小程序
                this.showNavBar = true
            } else {
                // 在微信网页
                this.showNavBar = true
            }
        },
        clickBack() {
            // var u = navigator.userAgent
            // if (u.indexOf('miniProgram') !== -1) {
            //     // 在微信小程序
            //     window.wx.miniProgram.navigateBack()
            // } else {
                // 在微信网页
                this.$router.go(-1)
            // }
        },
        goHome() {
            // if (this.KEEP_ALIVE_COMS.includes('Home')) {
            //     store.commit("REMOVE_KEEP_ALIVE_COM", 'Home')
            // }
            sessionStorage.setItem('reload',1)
            this.$router.replace({path:'/ai'})
        }
        
    },
}
</script>
<style scoped>
.img{
    width: 20px;
    height: 20px;
    background-size: cover;
}
</style>
